<template>
    <div class="page-title">
        <div class="title">
            <h3>Agent Bookings Report</h3>
        </div>
        <div class="filters">
            <el-form
                label-position="top"
            >
                <el-row>
                    <el-col :span="2" >
                        <el-form-item label="Types">
                            <el-select v-model="form.service"  placeholder="Select" size="small" clearable>
                                <el-option
                                    v-for="item in data.services"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item class="ml-2" label="Date Type">
                            <el-select v-model="form.type"  placeholder="Select" size="small">
                                <el-option
                                    v-for="item in types"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item class="ml-2" label="Month" size="small">
                            <el-date-picker
                                v-model="form.month"
                                type="month"
                                placeholder="Pick a month"
                                format="MMM/YYYY"
                                value-format="YYYY-MM"


                            />
                        </el-form-item>
                    </el-col>

                    <el-col :span="3">
                        <el-form-item class="ml-2" label=" .">
                            <el-button @click="getlist()"  type="primary" size="small"  round >Apply Filters</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>



            </el-form>



        </div>
    </div>

    <div v-if="!loading">

        <el-table :data="reports" show-summary  style="width: 100%">
            <el-table-column type="expand">
                <template #default="props">
                    <div class="m-4">
                        <h3>Bookings</h3>
                        <el-table :data="props.row.bookings" >
                            <el-table-column label="ID" prop="did" />
                            <el-table-column label="Name" prop="name" />
                            <el-table-column label="Agent Profit" prop="agentprofit" />
                            <el-table-column label="Profit" prop="profit" />
                            <el-table-column label="GST" prop="gst" />
                            <el-table-column label="TDS" prop="tds" />
                            <el-table-column label="Quote Price" prop="quote_price" />
                            <el-table-column fixed="right" label="" width="120">
                                <template #default="scope1">
                                    <el-button  type="primary"  @click="openbooking(scope1.row.link)">View Booking</el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="Agent" prop="agent.name" />
            <el-table-column label="Sales" prop="sales" />
            <el-table-column label="Agent Profit" prop="agentprofit" />
            <el-table-column label="Profit" prop="profit" />
            <el-table-column label="GST" prop="gst" />
           <!-- <el-table-column label="TDS" prop="tds" />-->
            <el-table-column label="Quote Price" prop="quote_price" />
        </el-table>


    </div>
    <div v-else>
        <el-card class="box-card mt-2 booking-list-box" v-for="i in 7" :key="i">
            <el-skeleton :rows="1" animated />
        </el-card>

    </div>

</template>
<style>

</style>
<script>
import  { ElTable,ElTableColumn,ElSpace,ElPagination,ElSelect, ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton  } from 'element-plus'
import 'element-plus/dist/index.css'
import moment from 'moment'
export default {
    name: "AgentBookingReportList",
    components: { ElTable,ElTableColumn,ElSpace,ElPagination,ElSelect,ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton },
    data() {
        return {
            loading: true,
            form:{
                month:moment().startOf('month').format('YYYY-MM'),
                service:'',
                type:0
            },
            data:{
                user:null,
                services:[]
            },
            reports:[],
            types:[
                {
                    value:0,
                    label:'Booking Date'
                },
                {
                    value:1,
                    label:'Departure Date'
                }

            ],
        }
    },
    mounted() {
        this.getlist();
    },
    methods: {
        getlist() {
            this.loading=true;
            let currentObj = this;
            axios.post('/report/agentbookings',this.form).then(function (response) {

                currentObj.reports=response.data.reports;
                currentObj.data=response.data.data;
                currentObj.loading=false;

            })
                .catch(function (error) {
                    currentObj.loading=false;
                });
        },
        openbooking(link){
            window.open(link, "_blank", "width="+screen.availWidth+",height="+screen.availHeight)

        }
    }
}
</script>

<style scoped>

</style>


